import {
  CANCEL_TAX_DEDUCTS,
  CANCEL_TAX_DEDUCTS_FAIL,
  CANCEL_TAX_DEDUCTS_SUCCESS,
  CHECK_INVOICES_CURRENT,
  CHECK_INVOICES_CURRENT_FAIL,
  CHECK_INVOICES_CURRENT_SUCCESS,
  CREATE_REGISTRY_DELEGATE,
  CREATE_REGISTRY_DELEGATE_FAIL,
  CREATE_REGISTRY_DELEGATE_SUCCESS,
  CREATE_REGISTRY_INVOICES,
  CREATE_REGISTRY_INVOICES_FAIL,
  CREATE_REGISTRY_INVOICES_SUCCESS,
  CREATE_REQUEST_INVOICE_CODE,
  CREATE_REQUEST_INVOICE_CODE_FAIL,
  CREATE_REQUEST_INVOICE_CODE_SUCCESS,
  CREATE_TAX_DEDUCTS,
  CREATE_TAX_DEDUCTS_FAIL,
  CREATE_TAX_DEDUCTS_REGISTRY,
  CREATE_TAX_DEDUCTS_REGISTRY_FAIL,
  CREATE_TAX_DEDUCTS_REGISTRY_SUCCESS,
  CREATE_TAX_DEDUCTS_SUCCESS,
  DELETE_TAX_DEDUCTS,
  DELETE_TAX_DEDUCTS_FAIL,
  DELETE_TAX_DEDUCTS_REGISTRY,
  DELETE_TAX_DEDUCTS_REGISTRY_FAIL,
  DELETE_TAX_DEDUCTS_REGISTRY_SUCCESS,
  DELETE_TAX_DEDUCTS_SUCCESS,
  DOWNLOAD_PDF_REGISTRY_INVOICES,
  DOWNLOAD_PDF_REGISTRY_INVOICES_FAIL,
  DOWNLOAD_PDF_REGISTRY_INVOICES_SUCCESS,
  DOWNLOAD_XML_REGISTRY_DELEGATE,
  DOWNLOAD_XML_REGISTRY_DELEGATE_FAIL,
  DOWNLOAD_XML_REGISTRY_DELEGATE_SUCCESS,
  DOWNLOAD_XML_REGISTRY_INVOICES,
  DOWNLOAD_XML_REGISTRY_INVOICES_FAIL,
  DOWNLOAD_XML_REGISTRY_INVOICES_SUCCESS,
  DOWNLOAD_XML_REQUEST_INVOICE_CODE,
  DOWNLOAD_XML_REQUEST_INVOICE_CODE_FAIL,
  DOWNLOAD_XML_REQUEST_INVOICE_CODE_SUCCESS,
  DOWNLOAD_XML_TAX_DEDUCTS,
  DOWNLOAD_XML_TAX_DEDUCTS_FAIL,
  DOWNLOAD_XML_TAX_DEDUCTS_REGISTRY,
  DOWNLOAD_XML_TAX_DEDUCTS_REGISTRY_FAIL,
  DOWNLOAD_XML_TAX_DEDUCTS_REGISTRY_SUCCESS,
  DOWNLOAD_XML_TAX_DEDUCTS_SUCCESS,
  EDIT_REGISTRY_DELEGATE,
  EDIT_REGISTRY_DELEGATE_FAIL,
  EDIT_REGISTRY_DELEGATE_SUCCESS,
  EDIT_REGISTRY_INVOICES,
  EDIT_REGISTRY_INVOICES_FAIL,
  EDIT_REGISTRY_INVOICES_SUCCESS,
  EDIT_REQUEST_INVOICE_CODE,
  EDIT_REQUEST_INVOICE_CODE_FAIL,
  EDIT_REQUEST_INVOICE_CODE_SUCCESS,
  EDIT_TAX_DEDUCTS,
  EDIT_TAX_DEDUCTS_FAIL,
  EDIT_TAX_DEDUCTS_REGISTRY,
  EDIT_TAX_DEDUCTS_REGISTRY_FAIL,
  EDIT_TAX_DEDUCTS_REGISTRY_SUCCESS,
  EDIT_TAX_DEDUCTS_SUCCESS,
  GET_DETAIL_REGISTRY_DELEGATE,
  GET_DETAIL_REGISTRY_DELEGATE_FAIL,
  GET_DETAIL_REGISTRY_DELEGATE_SUCCESS,
  GET_DETAIL_REGISTRY_INVOICES,
  GET_DETAIL_REGISTRY_INVOICES_FAIL,
  GET_DETAIL_REGISTRY_INVOICES_SUCCESS,
  GET_DETAIL_REQUEST_INVOICE_CODE,
  GET_DETAIL_REQUEST_INVOICE_CODE_FAIL,
  GET_DETAIL_REQUEST_INVOICE_CODE_SUCCESS,
  GET_DETAIL_TAX_DEDUCTS,
  GET_DETAIL_TAX_DEDUCTS_FAIL,
  GET_DETAIL_TAX_DEDUCTS_REGISTRY,
  GET_DETAIL_TAX_DEDUCTS_REGISTRY_FAIL,
  GET_DETAIL_TAX_DEDUCTS_REGISTRY_SUCCESS,
  GET_DETAIL_TAX_DEDUCTS_SUCCESS,
  GET_HISTORY_TRANSFER,
  GET_HISTORY_TRANSFER_FAIL,
  GET_HISTORY_TRANSFER_SUCCESS,
  GET_LIST_REGISTRY_DELEGATE,
  GET_LIST_REGISTRY_DELEGATE_FAIL,
  GET_LIST_REGISTRY_DELEGATE_SUCCESS,
  GET_LIST_REGISTRY_INVOICES,
  GET_LIST_REGISTRY_INVOICES_FAIL,
  GET_LIST_REGISTRY_INVOICES_SUCCESS,
  GET_LIST_REQUEST_INVOICE_CODE,
  GET_LIST_REQUEST_INVOICE_CODE_FAIL,
  GET_LIST_REQUEST_INVOICE_CODE_SUCCESS,
  GET_LIST_TAX_DEDUCTS,
  GET_LIST_TAX_DEDUCTS_FAIL,
  GET_LIST_TAX_DEDUCTS_REGISTRY,
  GET_LIST_TAX_DEDUCTS_REGISTRY_FAIL,
  GET_LIST_TAX_DEDUCTS_REGISTRY_SUCCESS,
  GET_LIST_TAX_DEDUCTS_SUCCESS,
  GET_REASON_DENY_RELEASE,
  GET_REASON_DENY_RELEASE_FAIL,
  GET_REASON_DENY_RELEASE_SUCCESS,
  PREVIEW_PDF,
  PREVIEW_PDF_FAIL,
  PREVIEW_PDF_REGISTER_INVOICE,
  PREVIEW_PDF_REGISTER_INVOICE_FAIL,
  PREVIEW_PDF_REGISTER_INVOICE_SUCCESS,
  PREVIEW_PDF_SUCCESS,
  RELEASE_REGISTRY_DELEGATE,
  RELEASE_REGISTRY_DELEGATE_FAIL,
  RELEASE_REGISTRY_DELEGATE_SUCCESS,
  RELEASE_REGISTRY_INVOICES,
  RELEASE_REGISTRY_INVOICES_FAIL,
  RELEASE_REGISTRY_INVOICES_SUCCESS,
  RELEASE_REQUEST_INVOICE_CODE,
  RELEASE_REQUEST_INVOICE_CODE_FAIL,
  RELEASE_REQUEST_INVOICE_CODE_SUCCESS,
  RELEASE_TAX_DEDUCTS,
  RELEASE_TAX_DEDUCTS_FAIL,
  RELEASE_TAX_DEDUCTS_REGISTRY,
  RELEASE_TAX_DEDUCTS_REGISTRY_FAIL,
  RELEASE_TAX_DEDUCTS_REGISTRY_SUCCESS,
  RELEASE_TAX_DEDUCTS_SUCCESS,
  RESET_CANCEL_TAX_DEDUCTS,
  RESET_CREATE_REGISTRY_DELEGATE,
  RESET_CREATE_REGISTRY_INVOICES,
  RESET_CREATE_REQUEST_INVOICE_CODE,
  RESET_CREATE_TAX_DEDUCTS,
  RESET_CREATE_TAX_DEDUCTS_REGISTRY,
  RESET_DELETE_TAX_DEDUCTS,
  RESET_DELETE_TAX_DEDUCTS_REGISTRY,
  RESET_DETAIL_TAX_DEDUCTS,
  RESET_DOWNLOAD_PDF_REGISTRY_INVOICES,
  RESET_DOWNLOAD_XML_REGISTRY_DELEGATE,
  RESET_DOWNLOAD_XML_REGISTRY_INVOICES,
  RESET_DOWNLOAD_XML_REQUEST_INVOICE_CODE,
  RESET_DOWNLOAD_XML_TAX_DEDUCTS,
  RESET_DOWNLOAD_XML_TAX_DEDUCTS_REGISTRY,
  RESET_EDIT_REGISTRY_DELEGATE,
  RESET_EDIT_REGISTRY_INVOICES,
  RESET_EDIT_REQUEST_INVOICE_CODE,
  RESET_EDIT_TAX_DEDUCTS,
  RESET_EDIT_TAX_DEDUCTS_REGISTRY,
  RESET_GET_HISTORY_TRANSFER,
  RESET_GET_REASON_DENY_RELEASE,
  RESET_LIST_REGISTRY_DELEGATE,
  RESET_LIST_REGISTRY_INVOICES,
  RESET_LIST_REQUEST_INVOICE_CODE,
  RESET_PREVIEW_FILE,
  RESET_PREVIEW_PDF_REGISTER_INVOICE,
  RESET_RELEASE_REGISTRY_DELEGATE,
  RESET_RELEASE_REGISTRY_INVOICES,
  RESET_RELEASE_REQUEST_INVOICE_CODE,
  RESET_RELEASE_TAX_DEDUCTS,
  RESET_RELEASE_TAX_DEDUCTS_REGISTRY,
  RESET_TRANSFER_USB,
  SET_COLUMN_VISIBLE_REGISTRY_DELEGATE,
  SET_COLUMN_VISIBLE_REGISTRY_INVOICES,
  SET_COLUMN_VISIBLE_REQUEST_INVOICE_CODE,
  SET_COLUMN_VISIBLE_TAX_DEDUCTS,
  SET_COLUMN_VISIBLE_TAX_DEDUCTS_REGISTRY,
  TRANSFER_USB,
  TRANSFER_USB_FAIL,
  TRANSFER_USB_SUCCESS,
} from "./actionTypes";
// PREVIEW_PDF_ISSUE_INVOICE
export const previewPdfRegisterInvoice = (id, typePreview = null) => ({
  type: PREVIEW_PDF_REGISTER_INVOICE,
  id,
  typePreview,
});

// PREVIEW_PDF Success
export const previewPdfRegisterInvoiceSuccess = data => ({
  type: PREVIEW_PDF_REGISTER_INVOICE_SUCCESS,
  data,
});

// previewPdfRegisterInvoiceFail
export const previewPdfRegisterInvoiceFail = error => ({
  type: PREVIEW_PDF_REGISTER_INVOICE_FAIL,
  error,
});

// resetPreviewFile
export const resetPreviewPdfRegisterInvoice = () => ({
  type: RESET_PREVIEW_PDF_REGISTER_INVOICE,
});
// Đăng ký sử dụng
export const getListRegistryInvoices = params => ({
  type: GET_LIST_REGISTRY_INVOICES,
  params,
});

export const getListRegistryInvoicesSuccess = (listData, totalCount) => ({
  type: GET_LIST_REGISTRY_INVOICES_SUCCESS,
  listData,
  totalCount,
});

export const getListRegistryInvoicesFail = error => ({
  type: GET_LIST_REGISTRY_INVOICES_FAIL,
  error,
});

export const resetListRegistryInvoices = error => ({
  type: RESET_LIST_REGISTRY_INVOICES,
});

// Ủy quyền lập hóa đơn
export const getListRegistryDelegate = params => ({
  type: GET_LIST_REGISTRY_DELEGATE,
  params,
});

export const getListRegistryDelegateSuccess = (listData, totalCount) => ({
  type: GET_LIST_REGISTRY_DELEGATE_SUCCESS,
  listData,
  totalCount,
});

export const getListRegistryDelegateFail = error => ({
  type: GET_LIST_REGISTRY_DELEGATE_FAIL,
  error,
});

export const resetListRegistryDelegate = error => ({
  type: RESET_LIST_REGISTRY_DELEGATE,
});

// Đề nghị cấp HDDT có mã
export const getListRequestInvoiceCode = params => ({
  type: GET_LIST_REQUEST_INVOICE_CODE,
  params,
});

export const getListRequestInvoiceCodeSuccess = (listData, totalCount) => ({
  type: GET_LIST_REQUEST_INVOICE_CODE_SUCCESS,
  listData,
  totalCount,
});

export const getListRequestInvoiceCodeFail = error => ({
  type: GET_LIST_REQUEST_INVOICE_CODE_FAIL,
  error,
});

export const resetListRequestInvoiceCode = error => ({
  type: RESET_LIST_REQUEST_INVOICE_CODE,
});

// Chi tiết Đăng ký sử dụng
export const getDetailRegistryInvoices = id => ({
  type: GET_DETAIL_REGISTRY_INVOICES,
  id,
});

export const getDetailRegistryInvoicesSuccess = data => ({
  type: GET_DETAIL_REGISTRY_INVOICES_SUCCESS,
  data,
});

export const getDetailRegistryInvoicesFail = error => ({
  type: GET_DETAIL_REGISTRY_INVOICES_FAIL,
  error,
});
// Kiểm tra DS tờ khai đã có trạng thái Hiệu lực
export const checkInvoicesCurrent = id => ({
  type: CHECK_INVOICES_CURRENT,
  id,
});

export const checkInvoicesCurrentSuccess = data => ({
  type: CHECK_INVOICES_CURRENT_SUCCESS,
  data,
});

export const checkInvoicesCurrentFail = error => ({
  type: CHECK_INVOICES_CURRENT_FAIL,
  error,
});

// Chi tiết Ủy quyền lập hóa đơn
export const getDetailRegistryDelegate = id => ({
  type: GET_DETAIL_REGISTRY_DELEGATE,
  id,
});

export const getDetailRegistryDelegateSuccess = data => ({
  type: GET_DETAIL_REGISTRY_DELEGATE_SUCCESS,
  data,
});

export const getDetailRegistryDelegateFail = error => ({
  type: GET_DETAIL_REGISTRY_DELEGATE_FAIL,
  error,
});

// Chi tiết Đề nghị cấp HDDT có mã
export const getDetailRequestInvoiceCode = id => ({
  type: GET_DETAIL_REQUEST_INVOICE_CODE,
  id,
});

export const getDetailRequestInvoiceCodeSuccess = data => ({
  type: GET_DETAIL_REQUEST_INVOICE_CODE_SUCCESS,
  data,
});

export const getDetailRequestInvoiceCodeFail = error => ({
  type: GET_DETAIL_REQUEST_INVOICE_CODE_FAIL,
  error,
});

// Tạo Đăng ký sử dụng
export const createRegistryInvoices = data => ({
  type: CREATE_REGISTRY_INVOICES,
  data,
});

export const createRegistryInvoicesSuccess = data => ({
  type: CREATE_REGISTRY_INVOICES_SUCCESS,
  data,
});

export const createRegistryInvoicesFail = error => ({
  type: CREATE_REGISTRY_INVOICES_FAIL,
  error,
});
export const resetCreateRegistryInvoices = error => ({
  type: RESET_CREATE_REGISTRY_INVOICES,
});

// EDIT Đăng ký sử dụng
export const editRegistryInvoices = (data, id) => ({
  type: EDIT_REGISTRY_INVOICES,
  data,
  id,
});

export const editRegistryInvoicesSuccess = data => ({
  type: EDIT_REGISTRY_INVOICES_SUCCESS,
  data,
});

export const editRegistryInvoicesFail = error => ({
  type: EDIT_REGISTRY_INVOICES_FAIL,
  error,
});
export const resetEditRegistryInvoices = error => ({
  type: RESET_EDIT_REGISTRY_INVOICES,
});

// Tạo Ủy quyền lập hóa đơn
export const createRegistryDelegate = data => ({
  type: CREATE_REGISTRY_DELEGATE,
  data,
});

export const createRegistryDelegateSuccess = data => ({
  type: CREATE_REGISTRY_DELEGATE_SUCCESS,
  data,
});

export const createRegistryDelegateFail = error => ({
  type: CREATE_REGISTRY_DELEGATE_FAIL,
  error,
});
export const resetCreateRegistryDelegate = error => ({
  type: RESET_CREATE_REGISTRY_DELEGATE,
});

// EDIT Ủy quyền lập hóa đơn
export const editRegistryDelegate = (data, id) => ({
  type: EDIT_REGISTRY_DELEGATE,
  data,
  id,
});

export const editRegistryDelegateSuccess = data => ({
  type: EDIT_REGISTRY_DELEGATE_SUCCESS,
  data,
});

export const editRegistryDelegateFail = error => ({
  type: EDIT_REGISTRY_DELEGATE_FAIL,
  error,
});
export const resetEditRegistryDelegate = error => ({
  type: RESET_EDIT_REGISTRY_DELEGATE,
});

// Tạo Đề nghị cấp HDDT có mã
export const createRequestInvoiceCode = data => ({
  type: CREATE_REQUEST_INVOICE_CODE,
  data,
});

export const createRequestInvoiceCodeSuccess = data => ({
  type: CREATE_REQUEST_INVOICE_CODE_SUCCESS,
  data,
});

export const createRequestInvoiceCodeFail = error => ({
  type: CREATE_REQUEST_INVOICE_CODE_FAIL,
  error,
});
export const resetCreateRequestInvoiceCode = error => ({
  type: RESET_CREATE_REQUEST_INVOICE_CODE,
});

// EDIT Đề nghị cấp HDDT có mã
export const editRequestInvoiceCode = (data, id) => ({
  type: EDIT_REQUEST_INVOICE_CODE,
  data,
  id,
});

export const editRequestInvoiceCodeSuccess = data => ({
  type: EDIT_REQUEST_INVOICE_CODE_SUCCESS,
  data,
});

export const editRequestInvoiceCodeFail = error => ({
  type: EDIT_REQUEST_INVOICE_CODE_FAIL,
  error,
});
export const resetEditRequestInvoiceCode = error => ({
  type: RESET_EDIT_REQUEST_INVOICE_CODE,
});

// DOWNLOAD_XML_REGISTRY_INVOICES
export const downloadXmlRegistryInvoices = (
  resource_id,
  fileDownloadName,
  responseType
) => ({
  type: DOWNLOAD_XML_REGISTRY_INVOICES,
  resource_id,
  fileDownloadName,
  responseType,
});

export const downloadXmlRegistryInvoicesSuccess = (
  fileDownloadResponse,
  fileDownload,
  fileDownloadName
) => ({
  type: DOWNLOAD_XML_REGISTRY_INVOICES_SUCCESS,
  fileDownloadResponse,
  fileDownload,
  fileDownloadName,
});

export const downloadXmlRegistryInvoicesFail = error => ({
  type: DOWNLOAD_XML_REGISTRY_INVOICES_FAIL,
  error,
});
export const resetDownloadXmlRegistryInvoices = error => ({
  type: RESET_DOWNLOAD_XML_REGISTRY_INVOICES,
});
// DOWNLOAD_PDF_REGISTRY_INVOICES
export const downloadPDFInvoices = (
  resource_id,
  fileDownloadName,
  downloadType,
  responseType
) => ({
  type: DOWNLOAD_PDF_REGISTRY_INVOICES,
  resource_id,
  fileDownloadName,
  downloadType,
  responseType,
});

export const downloadPDFInvoicesSuccess = (
  fileDownloadResponse,
  fileDownload,
  fileDownloadName
) => ({
  type: DOWNLOAD_PDF_REGISTRY_INVOICES_SUCCESS,
  fileDownloadResponse,
  fileDownload,
  fileDownloadName,
});

export const downloadPDFInvoicesFail = error => ({
  type: DOWNLOAD_PDF_REGISTRY_INVOICES_FAIL,
  error,
});
export const resetdownloadPDFInvoices = error => ({
  type: RESET_DOWNLOAD_PDF_REGISTRY_INVOICES,
});
// DOWNLOAD_XML_REGISTRY_DELEGATE
export const downloadXmlRegistryDelegate = (
  resource_id,
  fileDownloadName,
  responseType
) => ({
  type: DOWNLOAD_XML_REGISTRY_DELEGATE,
  resource_id,
  fileDownloadName,
  responseType,
});

export const downloadXmlRegistryDelegateSuccess = (
  fileDownloadResponse,
  fileDownload,
  fileDownloadName
) => ({
  type: DOWNLOAD_XML_REGISTRY_DELEGATE_SUCCESS,
  fileDownloadResponse,
  fileDownload,
  fileDownloadName,
});

export const downloadXmlRegistryDelegateFail = error => ({
  type: DOWNLOAD_XML_REGISTRY_DELEGATE_FAIL,
  error,
});
export const resetDownloadXmlRegistryDelegate = error => ({
  type: RESET_DOWNLOAD_XML_REGISTRY_DELEGATE,
});

// DOWNLOAD_XML_REQUEST_INVOICE_CODE
export const downloadXmlRequestInvoiceCode = (
  resource_id,
  fileDownloadName,
  responseType
) => ({
  type: DOWNLOAD_XML_REQUEST_INVOICE_CODE,
  resource_id,
  fileDownloadName,
  responseType,
});

export const downloadXmlRequestInvoiceCodeSuccess = (
  fileDownloadResponse,
  fileDownload,
  fileDownloadName
) => ({
  type: DOWNLOAD_XML_REQUEST_INVOICE_CODE_SUCCESS,
  fileDownloadResponse,
  fileDownload,
  fileDownloadName,
});

export const downloadXmlRequestInvoiceCodeFail = error => ({
  type: DOWNLOAD_XML_REQUEST_INVOICE_CODE_FAIL,
  error,
});
export const resetDownloadXmlRequestInvoiceCode = error => ({
  type: RESET_DOWNLOAD_XML_REQUEST_INVOICE_CODE,
});

//
// Phát hành tờ khai đăng ký sử dụng
export const releaseRegistryInvoices = id => ({
  type: RELEASE_REGISTRY_INVOICES,
  id,
});

export const releaseRegistryInvoicesSuccess = () => ({
  type: RELEASE_REGISTRY_INVOICES_SUCCESS,
});

export const releaseRegistryInvoicesFail = error => ({
  type: RELEASE_REGISTRY_INVOICES_FAIL,
  error,
});
export const resetReleaseRegistryInvoices = () => ({
  type: RESET_RELEASE_REGISTRY_INVOICES,
});

// Phát hành tờ khai ủy quyền lập hóa đơn
export const releaseRegistryDelegate = id => ({
  type: RELEASE_REGISTRY_DELEGATE,
  id,
});

export const releaseRegistryDelegateSuccess = () => ({
  type: RELEASE_REGISTRY_DELEGATE_SUCCESS,
});

export const releaseRegistryDelegateFail = error => ({
  type: RELEASE_REGISTRY_DELEGATE_FAIL,
  error,
});
export const resetReleaseRegistryDelegate = () => ({
  type: RESET_RELEASE_REGISTRY_DELEGATE,
});

// Phát hành ĐỀ NGHỊ CẤP HDDT CÓ MÃ
export const releaseRequestInvoiceCode = id => ({
  type: RELEASE_REQUEST_INVOICE_CODE,
  id,
});

export const releaseRequestInvoiceCodeSuccess = () => ({
  type: RELEASE_REQUEST_INVOICE_CODE_SUCCESS,
});

export const releaseRequestInvoiceCodeFail = error => ({
  type: RELEASE_REQUEST_INVOICE_CODE_FAIL,
  error,
});
export const resetReleaseRequestInvoiceCode = () => ({
  type: RESET_RELEASE_REQUEST_INVOICE_CODE,
});

// show/hide column
export const setColumnVisibleRegistryInvoices = (field, value) => ({
  type: SET_COLUMN_VISIBLE_REGISTRY_INVOICES,
  field,
  value,
});

export const setColumnVisibleRegistryDelegate = (field, value) => ({
  type: SET_COLUMN_VISIBLE_REGISTRY_DELEGATE,
  field,
  value,
});

export const setColumnVisibleRequestInvoiceCode = (field, value) => ({
  type: SET_COLUMN_VISIBLE_REQUEST_INVOICE_CODE,
  field,
  value,
});

export const setColumnVisibleTaxDeducts = (field, value) => ({
  type: SET_COLUMN_VISIBLE_TAX_DEDUCTS,
  field,
  value,
});

export const setColumnVisibleTaxDeductsRegistry = (field, value) => ({
  type: SET_COLUMN_VISIBLE_TAX_DEDUCTS_REGISTRY,
  field,
  value,
});

// PREVIEW_PDF
export const previewPdf = resourceId => ({
  type: PREVIEW_PDF,
  resourceId,
});

// PREVIEW_PDF Success
export const previewPdfSuccess = data => ({
  type: PREVIEW_PDF_SUCCESS,
  data,
});

// previewPdfFail
export const previewPdfFail = error => ({
  type: PREVIEW_PDF_FAIL,
  error,
});

// resetPreviewFile
export const resetPreviewFile = () => ({
  type: RESET_PREVIEW_FILE,
});

// transferUsb
export const transferUsb = (id, typeSend, content) => ({
  type: TRANSFER_USB,
  id,
  typeSend, // TYPE_REGISTER = 1, TYPE_INVOICE = 2
  content,
});

export const transferUsbSuccess = data => ({
  type: TRANSFER_USB_SUCCESS,
  data,
});

export const transferUsbFail = error => ({
  type: TRANSFER_USB_FAIL,
  error,
});
export const resetTransferUsb = error => ({
  type: RESET_TRANSFER_USB,
});

// GET_REASON_DENY_RELEASE
export const getReasonDenyRelease = (id, path) => ({
  type: GET_REASON_DENY_RELEASE,
  id,
  path,
});

export const getReasonDenyReleaseSuccess = data => ({
  type: GET_REASON_DENY_RELEASE_SUCCESS,
  data,
});

export const getReasonDenyReleaseFail = error => ({
  type: GET_REASON_DENY_RELEASE_FAIL,
  error,
});
export const resetGetReasonDenyRelease = error => ({
  type: RESET_GET_REASON_DENY_RELEASE,
});

// GET_HISTORY_TRANSFER
export const getHistoryTransfer = (id, path) => ({
  type: GET_HISTORY_TRANSFER,
  id,
  path,
});

export const getHistoryTransferSuccess = data => ({
  type: GET_HISTORY_TRANSFER_SUCCESS,
  data,
});

export const getHistoryTransferFail = error => ({
  type: GET_HISTORY_TRANSFER_FAIL,
  error,
});
export const resetGetHistoryTransfer = error => ({
  type: RESET_GET_HISTORY_TRANSFER,
});

// List tờ khai chứng từ
export const getListTaxDeductsRegistry = params => ({
  type: GET_LIST_TAX_DEDUCTS_REGISTRY,
  params,
});

export const getListTaxDeductsRegistrySuccess = (listData, totalCount) => ({
  type: GET_LIST_TAX_DEDUCTS_REGISTRY_SUCCESS,
  listData,
  totalCount,
});

export const getListTaxDeductsRegistryFail = error => ({
  type: GET_LIST_TAX_DEDUCTS_REGISTRY_FAIL,
  error,
});

export const resetListTaxDeductsRegistry = error => ({
  type: RESET_LIST_REGISTRY_INVOICES,
});

// Chi tiết tờ khai chứng từ
export const getDetailTaxDeductsRegistry = id => ({
  type: GET_DETAIL_TAX_DEDUCTS_REGISTRY,
  id,
});

export const getDetailTaxDeductsRegistrySuccess = data => ({
  type: GET_DETAIL_TAX_DEDUCTS_REGISTRY_SUCCESS,
  data,
});

export const getDetailTaxDeductsRegistryFail = error => ({
  type: GET_DETAIL_TAX_DEDUCTS_REGISTRY_FAIL,
  error,
});

// Tạo tờ khai chứng từ
export const createTaxDeductsRegistry = data => ({
  type: CREATE_TAX_DEDUCTS_REGISTRY,
  data,
});

export const createTaxDeductsRegistrySuccess = data => ({
  type: CREATE_TAX_DEDUCTS_REGISTRY_SUCCESS,
  data,
});

export const createTaxDeductsRegistryFail = error => ({
  type: CREATE_TAX_DEDUCTS_REGISTRY_FAIL,
  error,
});
export const resetCreateTaxDeductsRegistry = error => ({
  type: RESET_CREATE_TAX_DEDUCTS_REGISTRY,
});

// EDIT tờ khai chứng từ
export const editTaxDeductsRegistry = (data, id) => ({
  type: EDIT_TAX_DEDUCTS_REGISTRY,
  data,
  id,
});

export const editTaxDeductsRegistrySuccess = data => ({
  type: EDIT_TAX_DEDUCTS_REGISTRY_SUCCESS,
  data,
});

export const editTaxDeductsRegistryFail = error => ({
  type: EDIT_TAX_DEDUCTS_REGISTRY_FAIL,
  error,
});
export const resetEditTaxDeductsRegistry = error => ({
  type: RESET_EDIT_TAX_DEDUCTS_REGISTRY,
});

// Xóa tờ khai chứng từ
export const deleteTaxDeductsRegistry = id => ({
  type: DELETE_TAX_DEDUCTS_REGISTRY,
  id,
});

export const deleteTaxDeductsRegistrySuccess = data => ({
  type: DELETE_TAX_DEDUCTS_REGISTRY_SUCCESS,
  data,
});

export const deleteTaxDeductsRegistryFail = error => ({
  type: DELETE_TAX_DEDUCTS_REGISTRY_FAIL,
  error,
});
export const resetDeleteTaxDeductsRegistry = error => ({
  type: RESET_DELETE_TAX_DEDUCTS_REGISTRY,
});

// Phát hành tờ khai chứng từ
export const releaseTaxDeductsRegistry = id => ({
  type: RELEASE_TAX_DEDUCTS_REGISTRY,
  id,
});

export const releaseTaxDeductsRegistrySuccess = () => ({
  type: RELEASE_TAX_DEDUCTS_REGISTRY_SUCCESS,
});

export const releaseTaxDeductsRegistryFail = error => ({
  type: RELEASE_TAX_DEDUCTS_REGISTRY_FAIL,
  error,
});
export const resetReleaseTaxDeductsRegistry = () => ({
  type: RESET_RELEASE_TAX_DEDUCTS_REGISTRY,
});

// DOWNLOAD_XML_TAX_DEDUCTS
export const downloadXmlTaxDeductsRegistry = (
  resource_id,
  fileDownloadName,
  responseType
) => ({
  type: DOWNLOAD_XML_TAX_DEDUCTS_REGISTRY,
  resource_id,
  fileDownloadName,
  responseType,
});

export const downloadXmlTaxDeductsRegistrySuccess = (
  fileDownloadResponse,
  fileDownload,
  fileDownloadName
) => ({
  type: DOWNLOAD_XML_TAX_DEDUCTS_REGISTRY_SUCCESS,
  fileDownloadResponse,
  fileDownload,
  fileDownloadName,
});

export const downloadXmlTaxDeductsRegistryFail = error => ({
  type: DOWNLOAD_XML_TAX_DEDUCTS_REGISTRY_FAIL,
  error,
});
export const resetDownloadXmlTaxDeductsRegistry = error => ({
  type: RESET_DOWNLOAD_XML_TAX_DEDUCTS_REGISTRY,
});

// List chứng từ
export const getListTaxDeducts = params => ({
  type: GET_LIST_TAX_DEDUCTS,
  params,
});

export const getListTaxDeductsSuccess = (listData, totalCount) => ({
  type: GET_LIST_TAX_DEDUCTS_SUCCESS,
  listData,
  totalCount,
});

export const getListTaxDeductsFail = error => ({
  type: GET_LIST_TAX_DEDUCTS_FAIL,
  error,
});

export const resetListTaxDeducts = error => ({
  type: RESET_LIST_REGISTRY_INVOICES,
});

// Chi tiết chứng từ
export const getDetailTaxDeducts = id => ({
  type: GET_DETAIL_TAX_DEDUCTS,
  id,
});

export const getDetailTaxDeductsSuccess = data => ({
  type: GET_DETAIL_TAX_DEDUCTS_SUCCESS,
  data,
});

export const getDetailTaxDeductsFail = error => ({
  type: GET_DETAIL_TAX_DEDUCTS_FAIL,
  error,
});

export const resetDetailTaxDeducts = () => ({
  type: RESET_DETAIL_TAX_DEDUCTS,
});

// Tạo chứng từ
export const createTaxDeducts = data => ({
  type: CREATE_TAX_DEDUCTS,
  data,
});

export const createTaxDeductsSuccess = data => ({
  type: CREATE_TAX_DEDUCTS_SUCCESS,
  data,
});

export const createTaxDeductsFail = error => ({
  type: CREATE_TAX_DEDUCTS_FAIL,
  error,
});
export const resetCreateTaxDeducts = error => ({
  type: RESET_CREATE_TAX_DEDUCTS,
});

// EDIT chứng từ
export const editTaxDeducts = (data, id) => ({
  type: EDIT_TAX_DEDUCTS,
  data,
  id,
});

export const editTaxDeductsSuccess = data => ({
  type: EDIT_TAX_DEDUCTS_SUCCESS,
  data,
});

export const editTaxDeductsFail = error => ({
  type: EDIT_TAX_DEDUCTS_FAIL,
  error,
});
export const resetEditTaxDeducts = error => ({
  type: RESET_EDIT_TAX_DEDUCTS,
});

// Xóa chứng từ
export const deleteTaxDeducts = id => ({
  type: DELETE_TAX_DEDUCTS,
  id,
});

export const deleteTaxDeductsSuccess = data => ({
  type: DELETE_TAX_DEDUCTS_SUCCESS,
  data,
});

export const deleteTaxDeductsFail = error => ({
  type: DELETE_TAX_DEDUCTS_FAIL,
  error,
});
export const resetDeleteTaxDeducts = error => ({
  type: RESET_DELETE_TAX_DEDUCTS,
});

// Hủy chứng từ
export const cancelTaxDeducts = ids => ({
  type: CANCEL_TAX_DEDUCTS,
  ids,
});

export const cancelTaxDeductsSuccess = data => ({
  type: CANCEL_TAX_DEDUCTS_SUCCESS,
  data,
});

export const cancelTaxDeductsFail = error => ({
  type: CANCEL_TAX_DEDUCTS_FAIL,
  error,
});
export const resetCancelTaxDeducts = error => ({
  type: RESET_CANCEL_TAX_DEDUCTS,
});

// Phát hành chứng từ
export const releaseTaxDeducts = id => ({
  type: RELEASE_TAX_DEDUCTS,
  id,
});

export const releaseTaxDeductsSuccess = () => ({
  type: RELEASE_TAX_DEDUCTS_SUCCESS,
});

export const releaseTaxDeductsFail = error => ({
  type: RELEASE_TAX_DEDUCTS_FAIL,
  error,
});
export const resetReleaseTaxDeducts = () => ({
  type: RESET_RELEASE_TAX_DEDUCTS,
});

// DOWNLOAD_XML_TAX_DEDUCTS
export const downloadXmlTaxDeducts = (
  resource_id,
  fileDownloadName,
  responseType
) => ({
  type: DOWNLOAD_XML_TAX_DEDUCTS,
  resource_id,
  fileDownloadName,
  responseType,
});

export const downloadXmlTaxDeductsSuccess = (
  fileDownloadResponse,
  fileDownload,
  fileDownloadName
) => ({
  type: DOWNLOAD_XML_TAX_DEDUCTS_SUCCESS,
  fileDownloadResponse,
  fileDownload,
  fileDownloadName,
});

export const downloadXmlTaxDeductsFail = error => ({
  type: DOWNLOAD_XML_TAX_DEDUCTS_FAIL,
  error,
});
export const resetDownloadXmlTaxDeducts = error => ({
  type: RESET_DOWNLOAD_XML_TAX_DEDUCTS,
});
